import { Component } from 'react';

class BodyTop extends Component {
	render() {
		return (
			<>
				{/* Google Tag Manager (noscript) */}
				<noscript>
					<iframe
						src="https://www.googletagmanager.com/ns.html?id=GTM-MLQQMZV9"
						height="0"
						width="0"
						style={{ display: 'none', visibility: 'hidden' }}
						title="Google Tag Manager"></iframe>
				</noscript>
				{/* End Google Tag Manager (noscript) */}

				{/* Google Tag Manager (noscript) */}
				<noscript>
					<iframe
						src="https://www.googletagmanager.com/ns.html?id=GTM-MRJJ8NP4"
						height="0"
						width="0"
						style={{ display: 'none', visibility: 'hidden' }}
						title="Google Tag Manager"></iframe>
				</noscript>
				{/* End Google Tag Manager (noscript) */}
			</>
		);
	}
}

export default BodyTop;
